import clsx from 'clsx';
import { addCanalPlusGTMClass } from '../../services/lib/util';
import Link from 'next/link';

const VARIANT_STYLES = {
  h1: 'text-[2rem] leading-[2.5rem] font-bold xmd:text-[2.25rem] xmd:leading-[2.75rem]',
  h2: 'text-[1.5rem] leading-[2rem] font-semibold xmd:text-[1.75rem] xmd:leading-[2.25rem]',
  h3: 'text-[1.25rem] leading-[1.75rem] font-semibold xmd:text-[1.375rem] xmd:leading-[1.875rem]',
  h4: 'text-[1.125rem] leading-[1.5rem] font-semibold',
  h5: 'text-[1rem] leading-[1.5rem] font-semibold',
  h6: 'text-[0.875rem] leading-[1.25rem] font-semibold',
  body1: 'text-[1rem] leading-[1.5rem] font-normal',
  body2: 'text-[0.875rem] leading-[1.43] font-normal',
};

export const Title = ({ component: Component = 'span', variant = 'h2', link, text, className }) => {
  if (!text) return null;

  const typographyClasses = VARIANT_STYLES[variant] || VARIANT_STYLES.h2;

  return (
    <Component className={clsx('title m-0 block px-0 text-white', typographyClasses, className)}>
      {link ? (
        <Link href={link} className={clsx(addCanalPlusGTMClass(link), 'px-0 no-underline hover:underline')}>
          {text}
        </Link>
      ) : (
        text
      )}
    </Component>
  );
};
